module.exports = __webpack_public_path__ + "img/14.b890f546.png";